module.exports = __webpack_public_path__ + "static/img/ku-prime.ad4254f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ku-prime.jpg
// module id = NErb
// module chunks = 0